export const defaultExample = `/*
* Inputs for the script step appear as properties
* of the input object.
* This example shows how to access Inputs named
* 'APIKey' and 'Application Host'.
*/
//var department = input.APIKey;
//var address = input['Application Host'];

/*
* If an input is not required, it may not be
* present on the input object. Check that it
* is present before using it.
*/
//if (input.priorityLevel != null) {
//     var priority = input.priorityLevel.toUpperCase();
//}

/*
* If the script step has declared outputs, their
* values should be set on the output object.
* This example shows how to emit outputs named
* 'Priority' and 'Server Name'.
*/
//output.Priority = priority;
//output['Server Name'] = input['Application Host'];

/**
 * To use a library in this script, include the following statements, replacing
 * 'My Library' with the reference name you give the library when you select to
 * include it in the script.
 */
// var helloWorld = require('hello world')
// output['Message'] = helloWorld.createGreeting('sample message') // "Hello, sample message"

/*
* If the script step has an endpoint, it can
* be used to make HTTP requests.
* This example shows how to make a request using
* an endpoint named 'ExampleAPI' and an input
* named 'personId', then set the output property
* 'User Name' using the result.
*/
//var apiRequest = http.request({
//    'endpoint': 'ExampleAPI',
//    'path': '/api/1/persons/' + input.personId,
//    'method': 'GET'
//});
//var apiResponse = apiRequest.write();
//if (apiResponse.statusCode == 200) {
//    var person = JSON.parse(apiResponse.body);
//    output['User Name'] = person.username
//}
 `;

export const customHttpTriggerExample = `/******************************************************************************
* Custom HTTP Triggers
*
* Using an HTTP trigger lets you start a flow with a simple HTTP call.
*
* Each HTTP trigger is authenticated independently, which allows you to use it
* without storing the credentials of the authenticating user in an external
* system. The Script tab is where you define the internal logic that takes the
* HTTP request from another application, transforms the incoming information,
* and maps it to the outputs.
*
*
* When you create a new HTTP trigger, the script only brings what is included
* in the payload. You need to map properties from the request to the trigger
* outputs to use these properties in the steps in your flow.
*
* The following sample code shows how to parse the payload from an incoming
* HTTP request, then extract information from the payload and map it to
* outputs. You can use it as a template and then customize it to work with your
* specific application.
*
*/

/**
* Parse incoming data
*
* Typically, data is passed into an HTTP trigger as XML or JSON in the request
* body, but you can represent the data in another format or include it as a
* query parameter appended to the URL.
*
* The script's built-in request object enables you to access elements of the
* request, including the payload contained in the request body and any URL
* parameters. The following code snippets show how to retrieve these values.
* Choose the option that matches how your system includes data in the request to
* the HTTP trigger.
*/

//var payload = JSON.parse(request.body);  //For a JSON object
//var payload = JXON.parse(request.body);  //For XML
//var payload = request.parameters;        //For a query parameter

/******************************************************************************
* This example shows how to read a ticket number and summary from an incoming
* JSON payload and map the information to the Ticket ID and Ticket Title
* outputs of the trigger.
*
* The ticket number and summary are passed to the HTTP trigger as a JSON object
* in the request body.
*
* To run this example, uncomment the sample code and run the provided cURL
* command to target the trigger, including ticket number and summary values in
* the JSON payload. (Replace 'username' with your user name and the provided
* URL with the URL from the HTTP trigger's Settings tab.)
*
* curl -H "Content-Type: application/json" -- user username -X POST -d
* '{
*    "ticket number" : "1072128190001",
*    "summary": "Web App registration is down"
* }' "https://your.instance.com/api/integrations/1/functions/1d...fe0/triggers"
******************************************************************************/

/**
* Parse the request body (which contains a JSON object) and extract the payload
* data.
*/
//var payload = JSON.parse(request.body);
//output['Ticket Title'] = payload.summary;
//output['Ticket ID'] = payload['ticket number'];

/**
* Logging
* To write messages to the Activity Stream, use console.log().
*/
//console.log('Finished running HTTP Trigger script.');`;

export const libraryExample = `/*
 * Libraries allow you to write code and reuse it in multiple steps in Flow Designer.
 * This example shows you how to add a new function named 'createGreeting'.
 * To use this function in a script, include the following statements,
 * replacing 'hello world' with the library's reference name.

 * You can give each library a reference name when you select it to include it to a script.

 * var helloWorld = require('hello world');
 * output['Message'] = helloWorld.createGreeting('Dolly');   // "Hello, Dolly"

 * You cannot require one library in another library.
 */

exports.createGreeting = function(name) {
    if (!name) {
        name = 'World';
    }
    return 'Hello, ' + name;
}`;
